class WrapInSearch {
  constructor() {
    this.searchInputs = document.querySelectorAll('.wrapinsearch input, .mobiletrigger--input, .main-search__input');
    this.resultsBox = document.querySelector('.main-search__results');
    this.closeButtons = document.querySelectorAll('.main-search__close');
    this.oldSearchValue = '';
    this.searchTimeoutID = -1;
    this.searchAbortController = null;
    this.searchTimeoutThrottle = 500;
    this.resultLimit = 8;

    if (this.searchInputs.length) {
      this.initEvents();
    }
  }

  initEvents() {
    // Add event listeners for all input fields
    this.searchInputs.forEach((input) => {
      input.addEventListener('keyup', (evt) => this.handleInputChange(input, evt));
      input.addEventListener('change', (evt) => this.handleInputChange(input, evt));
    });

    // Close button functionality
    this.closeButtons.forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.closeSearch();
      });
    });

    // Escape key handling for all inputs
    this.searchInputs.forEach((input) => {
      input.addEventListener('keyup', (evt) => {
        if (evt.key === 'Escape') {
          this.closeSearch();
        }
      });
    });
  }

  handleInputChange(currentInput, evt) {
    const valueToSearch = currentInput.value;

    // Synchronize all input values
    this.searchInputs.forEach((input) => {
      if (input !== currentInput) {
        input.value = valueToSearch;
      }
    });

    // Open the search if typing in inputs
    if (valueToSearch.length > 0) {
      evt.preventDefault();
      document.body.classList.add('show-search');
    }

    // Close search if input is empty
    if (!valueToSearch.length) {
      this.closeSearch();
      return;
    }

    // Prevent excessive searches
    if (valueToSearch.length < 3 || valueToSearch === this.oldSearchValue) {
      return;
    }

    this.oldSearchValue = valueToSearch;

    // Abort previous search
    if (this.searchAbortController !== null) {
      this.searchAbortController.abort('Existing request not needed');
      this.searchAbortController = null;
    }

    clearTimeout(this.searchTimeoutID);

    // Display loading spinner
    this.resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';

    // Throttle search
    this.searchTimeoutID = setTimeout(() => {
      this.performSearch(valueToSearch);
    }, this.searchTimeoutThrottle);
  }

  performSearch(query) {
    this.searchAbortController = new AbortController();

    // Construct search URL (replace `theme.routes` with your base path)
    const ajaxUrl = new URL(`${window.location.origin}/search`);
    ajaxUrl.searchParams.set('q', query);
    ajaxUrl.searchParams.set('limit', this.resultLimit);

    fetch(ajaxUrl, { signal: this.searchAbortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then((response) => {
        this.displayResults(response);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.warn(error);
      });
  }

  displayResults(response) {
    const template = document.createElement('template');
    template.innerHTML = response;

    const resultsList = template.content.querySelector('.product-grid');
    this.resultsBox.innerHTML = '';

    if (resultsList && resultsList.children.length) {
      this.resultsBox.appendChild(resultsList);
    } else {
      this.resultsBox.innerHTML = '<div class="main-search__empty-message">No results found</div>';
    }
  }

  closeSearch() {
    // Reset input values and clear results
    this.searchInputs.forEach((input) => {
      input.value = '';
    });
    this.resultsBox.innerHTML = '';
    document.body.classList.remove('show-search');
    this.oldSearchValue = '';
    clearTimeout(this.searchTimeoutID);
    if (this.searchAbortController !== null) {
      this.searchAbortController.abort();
    }
  }
}

// Initialize the custom search handler
document.addEventListener('DOMContentLoaded', () => {
  new WrapInSearch();
});
